var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error mt-15"},[_c('i',{class:`icon ${_vm.fontAwsomeIconClass}`}),_c('div',{staticClass:"error-message"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }